import { useMemo } from 'react';

export const APP_T = {
  fr: {
    my_profile: 'Mon profil',
    view_store: 'Voir ma boutique',
    store_deploy_upgrade_title: 'Publiez votre boutique en ligne',
    store_deploy_upgrade_banner: 'Le Pack Gratuit ne permet pas de déployer votre boutique en ligne.',
    store_deploy_upgrade_body: 'Passez au Pack Entrepreneur ou Business pour rendre votre boutique accessible à vos clients et activer votre nom de domaine.',
    store_deploy_upgrade_cta: 'Voir les plans',
    store_deploy_upgrade_cancel: 'Plus tard',
    change_store: 'Changer de boutique',
    account_settings: 'Paramètres du compte',
    support: 'Support client',
    logout: 'Se déconnecter',
    search_aria: 'Rechercher',

    notifications: 'Notifications',
    mark_all_read: 'Tout marquer lu',
    no_notifications: 'Aucune notification',
    view_all_notifications: 'Voir toutes les notifications',
    notif_loading: 'Chargement des notifications…',
    notif_delete: 'Supprimer la notification',
    notif_clear_all: 'Tout supprimer',
    notif_error_loading: 'Impossible de charger les notifications',
    notif_error_update: 'Impossible de marquer la notification comme lue',
    notif_error_delete: 'Impossible de supprimer la notification',
    notif_out_of_stock: 'Rupture de stock',
    notif_limit_stock: 'Stock limite atteint',
    notif_expired: 'Produit expiré',
    notif_pre_expiration: 'Produit bientôt expiré',
    notif_due_expired: 'Échéance dépassée',
    notif_due_soon: 'Échéance proche',
    notif_theme_updated: 'Thème mis à jour',
    notif_order_update: 'Mise à jour commande',
    notif_customer_update: 'Mise à jour client',
    notif_variant_stock_changed: 'Le stock de variante a changé',
    notif_purchase_due: 'Une échéance d\'achat requiert votre attention',
    notif_theme_changed: 'Le thème de votre boutique a été modifié',
    notif_order_changed: 'Une commande a été mise à jour',
    notif_customer_changed: 'Un profil client a été mis à jour',
    notif_new_activity: 'Nouvelle activité de boutique',
    notif_ai_credits_empty: 'Crédits IA épuisés',
    notif_ai_credits_empty_body: 'Votre assistant IA ne répond plus : rechargez vos crédits.',
    notif_ai_human_requested: 'Un client demande une personne',
    notif_ai_human_requested_body: 'Répondez-lui dans la boîte de réception de votre Page Facebook (ou WhatsApp, Instagram). KIOAGENT reste silencieux dans cette conversation pendant 2 heures.',

    search_placeholder: 'Rechercher dans KIO…',
    search_placeholder_scope: (label) => `Rechercher dans ${label}…`,
    scope_all: 'Tout',
    scope_products: 'Produits',
    scope_orders: 'Commandes',
    scope_customers: 'Clients',
    scope_pages: 'Pages',
    nav_rapide: 'Navigation rapide',
    search_no_results: 'Aucun résultat pour',
    search_try_other: 'Essayez avec d\'autres mots-clés ou changez le filtre',
    search_hint_found: '— fonctionnalité trouvée dans :',
    search_hint_not_index: 'Cette option n\'est pas dans l\'index mais existe dans les sections suivantes',
    results_count: (n) => `${n} résultat${n > 1 ? 's' : ''}`,
    search_keys_hint: '↑↓ naviguer · ↵ ouvrir · Esc fermer',

    nav_home: 'Accueil',
    nav_section_sales: 'Ventes',
    nav_section_growth: 'Croissance',
    nav_section_channels: 'Canaux de vente',
    nav_section_logistics: 'Logistique',
    nav_orders: 'Commandes',
    nav_orders_all: 'Toutes les commandes',
    nav_abandoned: 'Paniers abandonnés',
    nav_refunded: 'Commandes remboursées',
    nav_products: 'Produits',
    nav_products_all: 'Tous les produits',
    nav_inventory: 'Inventaire',
    nav_categories: 'Catégories',
    nav_collections: 'Collections',
    nav_discounts: 'Réductions',
    nav_customers: 'Clients',
    nav_customers_all: 'Tous les clients',
    nav_invitations: 'Invitations',
    nav_customer_messages: 'Messages reçus',
    nav_staff: 'Équipe',
    nav_my_earnings: 'Mes gains',
    nav_marketing: 'Marketing',
    nav_analytics: 'Analytiques',
    nav_analytics_overview: 'Vue d\'ensemble',
    nav_analytics_finance: 'Finance',
    nav_analytics_orders: 'Commandes',
    nav_analytics_clients: 'Clients',
    nav_analytics_products: 'Produits & catalogue',
    nav_analytics_channels: 'Canaux de vente',
    nav_kiostore: 'KIOSTORE',
    nav_funnels: 'Funnels',
    nav_kiopos: 'KIOPOS',
    nav_kioagent: 'KIOAGENT',
    nav_ai_credits: 'Crédits IA',
    nav_shipping: 'Livraison',
    nav_tracking: 'Suivi des livraisons',
    nav_purchases: 'Gestion des achats',
    nav_purchase_orders: 'Bons de commande',
    nav_invoices: 'Factures',
    nav_suppliers: 'Fournisseurs',
    nav_affiliate: 'Système affilié',
    nav_personal_space: 'Espace personnel',
    nav_settings: 'Paramètres',
    nav_apps_tracking: 'Apps & Tracking',
    nav_newsletter: 'Bulletins',
    nav_marketing_campaigns: 'Campagnes E-mail',
    nav_sms_campaigns: 'Campagnes SMS',

    search_sub_home: 'Tableau de bord',
    search_sub_orders: 'Gérer vos commandes',
    search_sub_products: 'Catalogue produits',
    search_sub_customers: 'Base clients',
    search_sub_invitations: 'Invitations clients en attente',
    search_sub_customer_messages: 'Messages du formulaire contact',
    search_sub_discounts: 'Codes promo & offres',
    search_sub_marketing: 'Campagnes et e-mails',
    search_sub_analytics: 'Rapports et statistiques',
    search_sub_kiostore: 'Canal de vente en ligne',
    search_cod_shield: 'COD Shield',
    search_sub_cod_shield: 'Anti-fraude paiement à la livraison',
    search_sub_kiopos: 'Point de vente physique',
    search_sub_funnels: 'Landing pages produit à côté de la boutique',
    search_sub_kioagent: 'Agent de vente IA',
    search_sub_themes: 'Gérer les thèmes',
    search_sub_editor: 'Personnaliser le design',
    search_sub_codeed: 'CSS, JS, HTML',
    search_sub_naveditor: 'Menus header & footer',
    search_sub_settings: 'Configuration du compte',
    search_sub_shipping: 'Zones et tarifs',
    search_sub_tracking: 'Suivre les colis',
    search_sub_purchase_orders: 'Bons de commande fournisseurs',
    search_sub_invoices: 'Gestion des achats',
    search_sub_suppliers: 'Gestion des achats',
    search_sub_affiliate: 'Parrainage & commissions',
    search_sub_personal_space: 'Mon espace personnel',
    search_sub_abandoned: 'Commandes',
    search_sub_refunded: 'Commandes remboursées',
    search_themes: 'Thèmes',
    search_theme_editor: 'Éditeur de thème',
    search_code_editor: 'Éditeur de code',
    search_nav_editor: 'Éditeur de navigation',
    search_profile: 'Paramètres du compte',
    search_sub_profile: 'Changer le mot de passe · Informations personnelles',
    search_change_password: 'Changer le mot de passe',
    search_sub_change_password: 'Modifier votre mot de passe actuel',
    search_wallet: 'Portefeuille KIO',
    search_sub_wallet: 'Paiements, solde et retraits',
    search_sub_ai_credits: 'Solde, recharge et historique des crédits IA',
    search_store_pages: 'Pages de boutique',
    search_sub_store_pages: 'Créer et gérer les pages storefront',
    search_support_page: 'Support client',
    search_sub_support_page: 'Aide, assistance et contact support',
    search_notifications_page: 'Notifications',
    search_sub_notifications_page: 'Toutes les alertes et mises a jour',
    search_activities_page: 'Activites',
    search_sub_activities_page: 'Historique recent de la boutique',
    search_add_product: 'Ajouter un produit',
    search_sub_add_product: 'Creer un nouveau produit',
    search_add_theme: 'Ajouter un theme',
    search_sub_add_theme: 'Installer ou creer un nouveau theme',
    search_landing_editor: 'Editeur de page landing',
    search_sub_landing_editor: 'Construire une page marketing',
    search_theme_customizer: 'Personnalisation du theme',
    search_sub_theme_customizer: 'Reglages visuels et apparence',
  },

  en: {
    my_profile: 'My profile',
    view_store: 'View my store',
    store_deploy_upgrade_title: 'Publish your online store',
    store_deploy_upgrade_banner: 'The Free plan does not include online store deployment.',
    store_deploy_upgrade_body: 'Upgrade to the Entrepreneur or Business plan to make your store accessible to customers and activate your domain.',
    store_deploy_upgrade_cta: 'View plans',
    store_deploy_upgrade_cancel: 'Not now',
    change_store: 'Switch store',
    account_settings: 'Account settings',
    support: 'Customer support',
    logout: 'Log out',
    search_aria: 'Search',

    notifications: 'Notifications',
    mark_all_read: 'Mark all as read',
    no_notifications: 'No notifications',
    view_all_notifications: 'View all notifications',
    notif_loading: 'Loading notifications…',
    notif_delete: 'Delete notification',
    notif_clear_all: 'Clear all',
    notif_error_loading: 'Unable to load notifications',
    notif_error_update: 'Unable to mark notification as read',
    notif_error_delete: 'Unable to delete notification',
    notif_out_of_stock: 'Out of stock',
    notif_limit_stock: 'Low stock alert',
    notif_expired: 'Product expired',
    notif_pre_expiration: 'Product nearing expiration',
    notif_due_expired: 'Due date expired',
    notif_due_soon: 'Due date approaching',
    notif_theme_updated: 'Theme updated',
    notif_order_update: 'Order update',
    notif_customer_update: 'Customer update',
    notif_variant_stock_changed: 'Variant stock status changed',
    notif_purchase_due: 'A purchase due date needs your attention',
    notif_theme_changed: 'Your store theme has changed',
    notif_order_changed: 'An order has been updated',
    notif_customer_changed: 'A customer profile has been updated',
    notif_new_activity: 'New store activity',
    notif_ai_credits_empty: 'AI credits used up',
    notif_ai_credits_empty_body: 'Your AI assistant no longer replies: top up your credits.',
    notif_ai_human_requested: 'A customer asks for a person',
    notif_ai_human_requested_body: 'Reply to them in your Facebook Page inbox (or WhatsApp, Instagram). KIOAGENT stays silent in that conversation for 2 hours.',

    search_placeholder: 'Search in KIO…',
    search_placeholder_scope: (label) => `Search in ${label}…`,
    scope_all: 'All',
    scope_products: 'Products',
    scope_orders: 'Orders',
    scope_customers: 'Customers',
    scope_pages: 'Pages',
    nav_rapide: 'Quick navigation',
    search_no_results: 'No results for',
    search_try_other: 'Try different keywords or change the filter',
    search_hint_found: '— feature found in:',
    search_hint_not_index: 'This option is not in the index but exists in the following sections',
    results_count: (n) => `${n} result${n > 1 ? 's' : ''}`,
    search_keys_hint: '↑↓ navigate · ↵ open · Esc close',

    nav_home: 'Home',
    nav_section_sales: 'Sales',
    nav_section_growth: 'Growth',
    nav_section_channels: 'Sales channels',
    nav_section_logistics: 'Logistics',
    nav_orders: 'Orders',
    nav_orders_all: 'All orders',
    nav_abandoned: 'Abandoned carts',
    nav_refunded: 'Refunded orders',
    nav_products: 'Products',
    nav_products_all: 'All products',
    nav_inventory: 'Inventory',
    nav_categories: 'Categories',
    nav_collections: 'Collections',
    nav_discounts: 'Discounts',
    nav_customers: 'Customers',
    nav_customers_all: 'All customers',
    nav_invitations: 'Invitations',
    nav_customer_messages: 'Inbox messages',
    nav_staff: 'Team',
    nav_my_earnings: 'My earnings',
    nav_marketing: 'Marketing',
    nav_analytics: 'Analytics',
    nav_analytics_overview: 'Overview',
    nav_analytics_finance: 'Finance',
    nav_analytics_orders: 'Orders',
    nav_analytics_clients: 'Customers',
    nav_analytics_products: 'Products & catalog',
    nav_analytics_channels: 'Sales channels',
    nav_kiostore: 'KIOSTORE',
    nav_funnels: 'Funnels',
    nav_kiopos: 'KIOPOS',
    nav_kioagent: 'KIOAGENT',
    nav_ai_credits: 'AI credits',
    nav_shipping: 'Shipping',
    nav_tracking: 'Delivery tracking',
    nav_purchases: 'Purchase management',
    nav_purchase_orders: 'Purchase orders',
    nav_invoices: 'Invoices',
    nav_suppliers: 'Suppliers',
    nav_affiliate: 'Affiliate system',
    nav_personal_space: 'Personal space',
    nav_settings: 'Settings',
    nav_apps_tracking: 'Apps & Tracking',
    nav_newsletter: 'Newsletter',
    nav_marketing_campaigns: 'Email Campaigns',
    nav_sms_campaigns: 'SMS Campaigns',

    search_sub_home: 'Dashboard',
    search_sub_orders: 'Manage your orders',
    search_sub_products: 'Product catalog',
    search_sub_customers: 'Customer base',
    search_sub_invitations: 'Pending customer invitations',
    search_sub_customer_messages: 'Contact form messages',
    search_sub_discounts: 'Promo codes & offers',
    search_sub_marketing: 'Campaigns and emails',
    search_sub_analytics: 'Reports and statistics',
    search_sub_kiostore: 'Online sales channel',
    search_cod_shield: 'COD Shield',
    search_sub_cod_shield: 'Cash-on-delivery fraud protection',
    search_sub_kiopos: 'Physical point of sale',
    search_sub_funnels: 'Product landing pages next to the store',
    search_sub_kioagent: 'AI sales agent',
    search_sub_themes: 'Manage themes',
    search_sub_editor: 'Customize design',
    search_sub_codeed: 'CSS, JS, HTML',
    search_sub_naveditor: 'Header & footer menus',
    search_sub_settings: 'Account configuration',
    search_sub_shipping: 'Zones and rates',
    search_sub_tracking: 'Track packages',
    search_sub_purchase_orders: 'Supplier purchase orders',
    search_sub_invoices: 'Purchase management',
    search_sub_suppliers: 'Purchase management',
    search_sub_affiliate: 'Referrals & commissions',
    search_sub_personal_space: 'My personal space',
    search_sub_abandoned: 'Orders',
    search_sub_refunded: 'Refunded orders',
    search_themes: 'Themes',
    search_theme_editor: 'Theme editor',
    search_code_editor: 'Code editor',
    search_nav_editor: 'Navigation editor',
    search_profile: 'Account settings',
    search_sub_profile: 'Change password · Personal information',
    search_change_password: 'Change password',
    search_sub_change_password: 'Update your current password',
    search_wallet: 'KIO Wallet',
    search_sub_wallet: 'Payments, balance and withdrawals',
    search_sub_ai_credits: 'AI credit balance, top-up and history',
    search_store_pages: 'Store pages',
    search_sub_store_pages: 'Create and manage storefront pages',
    search_support_page: 'Customer support',
    search_sub_support_page: 'Help, assistance and support contact',
    search_notifications_page: 'Notifications',
    search_sub_notifications_page: 'All alerts and updates',
    search_activities_page: 'Activities',
    search_sub_activities_page: 'Recent store activity history',
    search_add_product: 'Add product',
    search_sub_add_product: 'Create a new product',
    search_add_theme: 'Add theme',
    search_sub_add_theme: 'Install or create a new theme',
    search_landing_editor: 'Landing page editor',
    search_sub_landing_editor: 'Build a marketing page',
    search_theme_customizer: 'Theme customizer',
    search_sub_theme_customizer: 'Visual settings and appearance',
  },

  ar: {
    my_profile: 'ملفي الشخصي',
    view_store: 'عرض متجري',
    store_deploy_upgrade_title: 'انشر متجرك الإلكتروني',
    store_deploy_upgrade_banner: 'الخطة المجانية لا تتضمن نشر المتجر الإلكتروني.',
    store_deploy_upgrade_body: 'قم بالترقية إلى خطة رائد الأعمال أو Business لجعل متجرك متاحًا للعملاء وتفعيل نطاقك.',
    store_deploy_upgrade_cta: 'عرض الخطط',
    store_deploy_upgrade_cancel: 'لاحقًا',
    change_store: 'تغيير المتجر',
    account_settings: 'إعدادات الحساب',
    support: 'دعم العملاء',
    logout: 'تسجيل الخروج',
    search_aria: 'بحث',

    notifications: 'الإشعارات',
    mark_all_read: 'تعليم الكل كمقروء',
    no_notifications: 'لا توجد إشعارات',
    view_all_notifications: 'عرض كل الإشعارات',
    notif_loading: 'جار تحميل الإشعارات…',
    notif_delete: 'حذف الإشعار',
    notif_clear_all: 'حذف الكل',
    notif_error_loading: 'تعذر تحميل الإشعارات',
    notif_error_update: 'تعذر تعليم الإشعار كمقروء',
    notif_error_delete: 'تعذر حذف الإشعار',
    notif_out_of_stock: 'نفاد المخزون',
    notif_limit_stock: 'تنبيه مخزون منخفض',
    notif_expired: 'منتج منتهي الصلاحية',
    notif_pre_expiration: 'منتج قريب الانتهاء',
    notif_due_expired: 'انتهت المهلة',
    notif_due_soon: 'المهلة قريبة',
    notif_theme_updated: 'تم تحديث القالب',
    notif_order_update: 'تحديث طلب',
    notif_customer_update: 'تحديث عميل',
    notif_variant_stock_changed: 'تغيرت حالة مخزون المتغير',
    notif_purchase_due: 'يوجد استحقاق شراء يحتاج انتباهك',
    notif_theme_changed: 'تم تغيير قالب المتجر',
    notif_order_changed: 'تم تحديث أحد الطلبات',
    notif_customer_changed: 'تم تحديث ملف عميل',
    notif_new_activity: 'نشاط جديد في المتجر',
    notif_ai_credits_empty: 'نفدت أرصدة الذكاء الاصطناعي',
    notif_ai_credits_empty_body: 'مساعدك الذكي لم يعد يرد: أعد شحن رصيدك.',
    notif_ai_human_requested: 'عميل يطلب التحدث مع شخص',
    notif_ai_human_requested_body: 'ردّ عليه من صندوق رسائل صفحتك على فيسبوك (أو واتساب، إنستغرام). يبقى KIOAGENT صامتًا في هذه المحادثة لمدة ساعتين.',

    search_placeholder: 'البحث في KIO…',
    search_placeholder_scope: (label) => `البحث في ${label}…`,
    scope_all: 'الكل',
    scope_products: 'المنتجات',
    scope_orders: 'الطلبات',
    scope_customers: 'العملاء',
    scope_pages: 'الصفحات',
    nav_rapide: 'التنقل السريع',
    search_no_results: 'لا توجد نتائج لـ',
    search_try_other: 'جرّب كلمات مفتاحية أخرى أو غيّر الفلتر',
    search_hint_found: '— وُجدت الميزة في:',
    search_hint_not_index: 'هذا الخيار غير موجود في الفهرس لكنه موجود في الأقسام التالية',
    results_count: (n) => `${n} نتيجة`,
    search_keys_hint: '↑↓ تنقل · ↵ فتح · Esc إغلاق',

    nav_home: 'الرئيسية',
    nav_section_sales: 'المبيعات',
    nav_section_growth: 'النمو',
    nav_section_channels: 'قنوات البيع',
    nav_section_logistics: 'اللوجستيات',
    nav_orders: 'الطلبات',
    nav_orders_all: 'جميع الطلبات',
    nav_abandoned: 'السلات المهجورة',
    nav_refunded: 'الطلبات المستردة',
    nav_products: 'المنتجات',
    nav_products_all: 'جميع المنتجات',
    nav_inventory: 'المخزون',
    nav_categories: 'الفئات',
    nav_collections: 'المجموعات',
    nav_discounts: 'التخفيضات',
    nav_customers: 'العملاء',
    nav_customers_all: 'جميع العملاء',
    nav_invitations: 'الدعوات',
    nav_customer_messages: 'الرسائل الواردة',
    nav_staff: 'الفريق',
    nav_my_earnings: 'أرباحي',
    nav_marketing: 'التسويق',
    nav_analytics: 'التحليلات',
    nav_analytics_overview: 'نظرة عامة',
    nav_analytics_finance: 'المالية',
    nav_analytics_orders: 'الطلبات',
    nav_analytics_clients: 'العملاء',
    nav_analytics_products: 'المنتجات والكتالوج',
    nav_analytics_channels: 'قنوات البيع',
    nav_kiostore: 'KIOSTORE',
    nav_funnels: 'مسارات البيع',
    nav_kiopos: 'KIOPOS',
    nav_kioagent: 'KIOAGENT',
    nav_ai_credits: 'أرصدة الذكاء الاصطناعي',
    nav_shipping: 'التوصيل',
    nav_tracking: 'تتبع التوصيل',
    nav_purchases: 'إدارة المشتريات',
    nav_purchase_orders: 'أوامر الشراء',
    nav_invoices: 'الفواتير',
    nav_suppliers: 'الموردون',
    nav_affiliate: 'نظام الإحالة',
    nav_personal_space: 'المساحة الشخصية',
    nav_settings: 'الإعدادات',
    nav_apps_tracking: 'التطبيقات والتتبع',
    nav_newsletter: 'النشرة البريدية',
    nav_marketing_campaigns: 'حملات البريد',
    nav_sms_campaigns: 'حملات SMS',

    search_sub_home: 'لوحة التحكم',
    search_sub_orders: 'إدارة طلباتك',
    search_sub_products: 'كتالوج المنتجات',
    search_sub_customers: 'قاعدة العملاء',
    search_sub_invitations: 'دعوات العملاء المعلقة',
    search_sub_customer_messages: 'رسائل نموذج الاتصال',
    search_sub_discounts: 'أكواد ترويجية وعروض',
    search_sub_marketing: 'الحملات والبريد',
    search_sub_analytics: 'التقارير والإحصائيات',
    search_sub_kiostore: 'قناة البيع عبر الإنترنت',
    search_cod_shield: 'COD Shield',
    search_sub_cod_shield: 'الحماية من الاحتيال في الدفع عند الاستلام',
    search_sub_kiopos: 'نقطة البيع الفعلية',
    search_sub_funnels: 'صفحات هبوط للمنتجات إلى جانب المتجر',
    search_sub_kioagent: 'وكيل مبيعات بالذكاء الاصطناعي',
    search_sub_themes: 'إدارة القوالب',
    search_sub_editor: 'تخصيص التصميم',
    search_sub_codeed: 'CSS, JS, HTML',
    search_sub_naveditor: 'قوائم الرأس والتذييل',
    search_sub_settings: 'إعدادات الحساب',
    search_sub_shipping: 'المناطق والأسعار',
    search_sub_tracking: 'تتبع الطرود',
    search_sub_purchase_orders: 'أوامر الشراء من الموردين',
    search_sub_invoices: 'إدارة المشتريات',
    search_sub_suppliers: 'إدارة المشتريات',
    search_sub_affiliate: 'الإحالة والعمولات',
    search_sub_personal_space: 'مساحتي الشخصية',
    search_sub_abandoned: 'الطلبات',
    search_sub_refunded: 'الطلبات المستردة',
    search_themes: 'القوالب',
    search_theme_editor: 'محرر القالب',
    search_code_editor: 'محرر الكود',
    search_nav_editor: 'محرر التنقل',
    search_profile: 'إعدادات الحساب',
    search_sub_profile: 'تغيير كلمة المرور · المعلومات الشخصية',
    search_change_password: 'تغيير كلمة المرور',
    search_sub_change_password: 'تعديل كلمة المرور الحالية',
    search_wallet: 'محفظة KIO',
    search_sub_wallet: 'المدفوعات والرصد والسحب',
    search_sub_ai_credits: 'رصيد وشحن وسجل أرصدة الذكاء الاصطناعي',
    search_store_pages: 'صفحات المتجر',
    search_sub_store_pages: 'إنشاء وإدارة صفحات الواجهة',
    search_support_page: 'دعم العملاء',
    search_sub_support_page: 'مساعدة ودعم والتواصل مع الفريق',
    search_notifications_page: 'الإشعارات',
    search_sub_notifications_page: 'كل التنبيهات والتحديثات',
    search_activities_page: 'الأنشطة',
    search_sub_activities_page: 'سجل نشاط المتجر الأخير',
    search_add_product: 'إضافة منتج',
    search_sub_add_product: 'إنشاء منتج جديد',
    search_add_theme: 'إضافة قالب',
    search_sub_add_theme: 'تثبيت أو إنشاء قالب جديد',
    search_landing_editor: 'محرر صفحة الهبوط',
    search_sub_landing_editor: 'بناء صفحة تسويقية',
    search_theme_customizer: 'تخصيص القالب',
    search_sub_theme_customizer: 'إعدادات الشكل والمظهر',
  },
};

export function useAppT(lang) {
  return useMemo(() => {
    const dict = APP_T[lang] ?? APP_T.fr;
    return function t(key, ...args) {
      const val = dict[key] ?? APP_T.fr[key] ?? key;
      if (typeof val === 'function') return val(...args);
      return val;
    };
  }, [lang]);
}

/** Base search entries — titles/subtitles resolved via titleKey / subtitleKey */
export const SEARCH_INDEX_BASE = [
  // ── Pages principales ──────────────────────────────────────────────────────
  { id: 'nav-home',      titleKey: 'nav_home',  subtitleKey: 'search_sub_home',  url: '/',  scope: 'pages',
    keywords: ['accueil', 'home', 'dashboard', 'لوحة التحكم', 'الرئيسية', 'تابلو'] },

  // ── Commandes ─────────────────────────────────────────────────────────────
  { id: 'nav-orders',    titleKey: 'nav_orders', subtitleKey: 'search_sub_orders', url: '/orders', scope: 'pages',
    keywords: ['commande', 'commandes', 'order', 'orders', 'الطلبات', 'طلب', 'طلبات', 'ventes'] },
  { id: 'nav-abandoned', titleKey: 'nav_abandoned', subtitleKey: 'search_sub_abandoned', url: '/orders/abandoned', scope: 'pages',
    keywords: ['panier', 'paniers', 'abandonné', 'abandonnés', 'سلة مهجورة', 'السلات المهجورة', 'سلة', 'cart'] },
  { id: 'nav-refunded',  titleKey: 'nav_refunded',  subtitleKey: 'search_sub_refunded',  url: '/orders/refunded',  scope: 'pages',
    keywords: ['remboursé', 'remboursement', 'refund', 'refunded', 'مسترد', 'استرداد', 'الطلبات المستردة'] },

  // ── Produits ──────────────────────────────────────────────────────────────
  { id: 'nav-products',   titleKey: 'nav_products',    subtitleKey: 'search_sub_products',   url: '/products',             scope: 'pages',
    keywords: ['produit', 'produits', 'product', 'catalogue', 'المنتجات', 'منتج', 'كتالوج'] },
  { id: 'nav-inventory',  titleKey: 'nav_inventory',   subtitleKey: 'search_sub_products',   url: '/products/inventory',   scope: 'pages',
    keywords: ['stock', 'stocks', 'inventaire', 'inventory', 'sku', 'المخزون', 'مخزون', 'rupture'] },
  { id: 'nav-categories', titleKey: 'nav_categories',  subtitleKey: 'search_sub_products',   url: '/products/categories',  scope: 'pages',
    keywords: ['categorie', 'categories', 'category', 'catalogue', 'الفئات', 'فئة', 'فئات', 'classification'] },
  { id: 'nav-collections',titleKey: 'nav_collections', subtitleKey: 'search_sub_products',   url: '/products/collections', scope: 'pages',
    keywords: ['collection', 'collections', 'catalogue', 'المجموعات', 'مجموعة', 'مجموعات', 'groupe'] },
  { id: 'nav-add-product',titleKey: 'search_add_product', subtitleKey: 'search_sub_add_product', url: '/products/add',    scope: 'pages',
    keywords: ['nouveau produit', 'new product', 'add product', 'ajouter produit', 'إضافة منتج', 'منتج جديد', 'créer produit'] },

  // ── Clients ───────────────────────────────────────────────────────────────
  { id: 'nav-customers',  titleKey: 'nav_customers',   subtitleKey: 'search_sub_customers',  url: '/customers',            scope: 'pages',
    keywords: ['client', 'clients', 'customer', 'customers', 'العملاء', 'عميل', 'عملاء', 'acheteur'] },
  { id: 'nav-invitations',titleKey: 'nav_invitations', subtitleKey: 'search_sub_invitations', url: '/customers/invitations', scope: 'pages',
    keywords: ['invitation', 'invitations', 'الدعوات', 'دعوة', 'دعوات', 'invite', 'pending'] },
  { id: 'nav-customer-messages', titleKey: 'nav_customer_messages', subtitleKey: 'search_sub_customer_messages', url: '/customers/messages', scope: 'pages',
    keywords: ['message', 'messages', 'contact', 'formulaire', 'الرسائل', 'رسائل', 'رسالة', 'inbox', 'messagerie'] },

  // ── Équipe ────────────────────────────────────────────────────────────────
  { id: 'nav-staff',      titleKey: 'nav_staff', subtitleKey: 'search_sub_settings', url: '/staff', scope: 'pages',
    keywords: ['equipe', 'team', 'staff', 'employe', 'employes', 'permission', 'permissions', 'الفريق', 'فريق', 'موظف', 'صلاحيات', 'accès', 'roles'] },
  { id: 'nav-my-earnings', titleKey: 'nav_my_earnings', subtitleKey: 'search_sub_settings', url: '/my-earnings', scope: 'pages',
    keywords: ['mes gains', 'gains', 'paie', 'fiche de paie', 'salaire', 'commission', 'commissions', 'ma remuneration', 'mon solde', 'أرباحي', 'راتب', 'عمولة', 'رصيدي'] },

  // ── Réductions ────────────────────────────────────────────────────────────
  { id: 'nav-discounts',  titleKey: 'nav_discounts',   subtitleKey: 'search_sub_discounts',  url: '/discounts',            scope: 'pages',
    keywords: ['promo', 'code promo', 'coupon', 'remise', 'discount', 'التخفيضات', 'تخفيض', 'خصم', 'كود', 'كوبون', 'offre', 'réduction'] },

  // ── Marketing ─────────────────────────────────────────────────────────────
  { id: 'nav-marketing',  titleKey: 'nav_marketing',   subtitleKey: 'search_sub_marketing',  url: '/marketing/bulletins',  scope: 'pages',
    keywords: ['marketing', 'التسويق', 'campagne', 'bulletin'] },
  { id: 'nav-newsletter', titleKey: 'nav_newsletter',  subtitleKey: 'search_sub_marketing',  url: '/marketing/bulletins',  scope: 'pages',
    keywords: ['newsletter', 'bulletin', 'bulletins', 'النشرة البريدية', 'النشرة', 'abonné', 'abonnés', 'email list'] },
  { id: 'nav-campaigns',  titleKey: 'nav_marketing_campaigns', subtitleKey: 'search_sub_marketing', url: '/marketing/campagnes', scope: 'pages',
    keywords: ['campagne', 'campagnes', 'campaign', 'email marketing', 'الحملات', 'حملة', 'حملات', 'emailing', 'mailing'] },
  { id: 'nav-sms',        titleKey: 'nav_sms_campaigns', subtitleKey: 'search_sub_marketing', url: '/marketing/sms', scope: 'pages',
    keywords: ['sms', 'campagnes sms', 'message sms', 'حملات sms', 'رسائل نصية', 'texto'] },

  // ── Analytiques ───────────────────────────────────────────────────────────
  { id: 'nav-analytics',  titleKey: 'nav_analytics',   subtitleKey: 'search_sub_analytics',  url: '/analytics/vue-ensemble', scope: 'pages',
    keywords: ['analytique', 'analytiques', 'analytics', 'statistique', 'statistiques', 'التحليلات', 'تقارير', 'إحصائيات', 'rapport', 'reporting'] },
  { id: 'nav-analytics-overview', titleKey: 'nav_analytics_overview', subtitleKey: 'search_sub_analytics', url: '/analytics/vue-ensemble', scope: 'pages',
    keywords: ['overview', 'vue ensemble', 'dashboard', 'reporting', 'نظرة عامة', 'لوحة', 'résumé', 'synthèse'] },
  { id: 'nav-analytics-finance',  titleKey: 'nav_analytics_finance',  subtitleKey: 'search_sub_analytics', url: '/analytics/finance',       scope: 'pages',
    keywords: ['finance', 'revenu', 'revenus', 'revenue', 'profit', 'ca', 'chiffre affaires', 'المالية', 'الإيرادات', 'أرباح', 'gains'] },
  { id: 'nav-analytics-orders',   titleKey: 'nav_analytics_orders',   subtitleKey: 'search_sub_analytics', url: '/analytics/commandes',     scope: 'pages',
    keywords: ['stats commandes', 'order stats', 'commandes analytics', 'إحصائيات الطلبات', 'تقرير الطلبات'] },
  { id: 'nav-analytics-clients',  titleKey: 'nav_analytics_clients',  subtitleKey: 'search_sub_analytics', url: '/analytics/clients',       scope: 'pages',
    keywords: ['stats clients', 'customer stats', 'clients analytics', 'إحصائيات العملاء', 'تقرير العملاء'] },
  { id: 'nav-analytics-products', titleKey: 'nav_analytics_products', subtitleKey: 'search_sub_analytics', url: '/analytics/produits',      scope: 'pages',
    keywords: ['stats produits', 'product stats', 'catalogue analytics', 'إحصائيات المنتجات', 'تقرير المنتجات'] },
  { id: 'nav-analytics-channels', titleKey: 'nav_analytics_channels', subtitleKey: 'search_sub_analytics', url: '/analytics/canaux',        scope: 'pages',
    keywords: ['stats canaux', 'channel stats', 'canaux analytics', 'إحصائيات القنوات', 'قنوات'] },

  // ── Canaux de vente ───────────────────────────────────────────────────────
  { id: 'nav-kiostore',   titleKey: 'nav_kiostore',    subtitleKey: 'search_sub_kiostore',   url: '/channels/kiostore',    scope: 'pages',
    keywords: ['boutique', 'store', 'kiostore', 'المتجر', 'البوتيك', 'domaine', 'paiement', 'cod', 'pixel', 'plan', 'abonnement'] },
  { id: 'nav-cod-shield', titleKey: 'search_cod_shield', subtitleKey: 'search_sub_cod_shield', url: '/channels/kiostore?tab=paiement', scope: 'pages',
    keywords: ['cod', 'cod shield', 'bouclier cod', 'bouclier', 'shield', 'honeypot', 'anti-fraude', 'antifraude', 'fraude', 'fraud', 'paiement livraison', 'cash on delivery', 'درع', 'الدفع عند الاستلام', 'احتيال', 'حماية', 'ban', 'blocage'] },
  { id: 'nav-wallet',     titleKey: 'search_wallet',   subtitleKey: 'search_sub_wallet',     url: '/wallet',               scope: 'pages',
    keywords: ['wallet', 'portefeuille', 'solde', 'balance', 'retrait', 'virement', 'withdraw', 'المحفظة', 'رصيد', 'سحب', 'paiements'] },
  { id: 'nav-kiopos',     titleKey: 'nav_kiopos',      subtitleKey: 'search_sub_kiopos',     url: '/channels/kiopos',      scope: 'pages',
    keywords: ['pos', 'caisse', 'point de vente', 'نقطة البيع', 'كاشير', 'boutique physique', 'terminal'] },
  { id: 'nav-funnels',    titleKey: 'nav_funnels',     subtitleKey: 'search_sub_funnels',    url: '/funnels',              scope: 'pages',
    keywords: ['funnel', 'funnels', 'landing', 'landing page', 'page produit', 'tunnel de vente', 'مسار البيع', 'صفحة هبوط'] },
  // Masqué dans buildSearchIndex() sans accès KIOAGENT
  { id: 'nav-kioagent',   titleKey: 'nav_kioagent',    subtitleKey: 'search_sub_kioagent',   url: '/channels/kioagent',    scope: 'pages',
    keywords: ['agent', 'ia', 'ai', 'chatbot', 'bot', 'الوكيل', 'ذكاء اصطناعي', 'chat'] },
  { id: 'nav-ai-credits', titleKey: 'nav_ai_credits',  subtitleKey: 'search_sub_ai_credits', url: '/ai-credits',           scope: 'pages',
    keywords: ['credit', 'credits', 'crédit', 'crédits', 'crédits ia', 'ai credits', 'recharge', 'recharger', 'top up', 'ia', 'ai', 'رصيد', 'شحن', 'أرصدة', 'ذكاء اصطناعي'] },

  // ── Thèmes & design ───────────────────────────────────────────────────────
  { id: 'nav-themes',           titleKey: 'search_themes',           subtitleKey: 'search_sub_themes',           url: '/themes/manage',                scope: 'pages',
    keywords: ['theme', 'themes', 'قالب', 'القوالب', 'design', 'template', 'modèle'] },
  { id: 'nav-add-theme',        titleKey: 'search_add_theme',        subtitleKey: 'search_sub_add_theme',        url: '/themes/add',                   scope: 'pages',
    keywords: ['add theme', 'ajouter theme', 'new theme', 'installer theme', 'إضافة قالب', 'قالب جديد'] },
  { id: 'nav-codeed',           titleKey: 'search_code_editor',      subtitleKey: 'search_sub_codeed',           url: '/themes/code-editor',           scope: 'pages',
    keywords: ['code', 'css', 'html', 'js', 'javascript', 'liquid', 'محرر الكود', 'كود', 'برمجة'] },
  { id: 'nav-landing-editor',   titleKey: 'search_landing_editor',   subtitleKey: 'search_sub_landing_editor',   url: '/themes/landing-editor',        scope: 'pages',
    keywords: ['landing', 'landing page', 'page marketing', 'محرر صفحة الهبوط', 'صفحة هبوط', 'page atterrissage'] },
  { id: 'nav-theme-customizer', titleKey: 'search_theme_customizer', subtitleKey: 'search_sub_theme_customizer', url: '/themes/customizer',            scope: 'pages',
    keywords: ['customizer', 'personnalisation', 'appearance', 'apparence', 'المظهر', 'تخصيص', 'تصميم', 'réglages visuels', 'éditeur thème', 'theme editor', 'محرر القالب', 'couleur', 'slider', 'hero', 'sections', 'design'] },
  { id: 'nav-naveditor',        titleKey: 'search_nav_editor',       subtitleKey: 'search_sub_naveditor',        url: '/channels/kiostore/navigation', scope: 'pages',
    keywords: ['menu', 'navigation', 'header', 'footer', 'قائمة', 'الترويسة', 'محرر التنقل', 'liens'] },
  { id: 'nav-store-pages',      titleKey: 'search_store_pages',      subtitleKey: 'search_sub_store_pages',      url: '/channels/kiostore/pages',      scope: 'pages',
    keywords: ['pages', 'page', 'cms', 'store pages', 'pages boutique', 'الصفحات', 'صفحات', 'صفحة', 'contenu'] },

  // ── Livraison & logistique ────────────────────────────────────────────────
  { id: 'nav-shipping',   titleKey: 'nav_shipping',    subtitleKey: 'search_sub_shipping',   url: '/shipping',             scope: 'pages',
    keywords: ['livraison', 'shipping', 'yalidine', 'maystro', 'ecotrack', 'noest', 'zr', 'التوصيل', 'الشحن', 'wilaya', 'ولاية', 'zones', 'tarifs', 'taux', 'frais', 'transporteur', 'livreur'] },
  { id: 'nav-tracking',   titleKey: 'nav_tracking',    subtitleKey: 'search_sub_tracking',   url: '/tracking',             scope: 'pages',
    keywords: ['suivi', 'tracking', 'colis', 'التتبع', 'تتبع', 'طرد', 'طرود', 'livraison suivi', 'تتبع الشحن'] },

  // ── Achats / Fournisseurs ─────────────────────────────────────────────────
  { id: 'nav-purchase-orders', titleKey: 'nav_purchase_orders', subtitleKey: 'search_sub_purchase_orders', url: '/purchases/purchase-orders', scope: 'pages',
    keywords: ['achat', 'achats', 'purchase', 'bon de commande', 'bons de commande', 'المشتريات', 'أوامر الشراء', 'أمر شراء', 'commande fournisseur'] },
  { id: 'nav-invoices',   titleKey: 'nav_invoices',    subtitleKey: 'search_sub_invoices',   url: '/purchases/invoices',   scope: 'pages',
    keywords: ['facture', 'factures', 'invoice', 'invoices', 'الفواتير', 'فاتورة', 'facturation', 'document'] },
  { id: 'nav-suppliers',  titleKey: 'nav_suppliers',   subtitleKey: 'search_sub_suppliers',  url: '/purchases/suppliers',  scope: 'pages',
    keywords: ['fournisseur', 'fournisseurs', 'supplier', 'suppliers', 'الموردون', 'مورد', 'موردون', 'grossiste', 'partenaire'] },

  // ── Affiliation ───────────────────────────────────────────────────────────
  { id: 'nav-affiliate',  titleKey: 'nav_affiliate',   subtitleKey: 'search_sub_affiliate',  url: '/affiliate',            scope: 'pages',
    keywords: ['affiliate', 'affilié', 'affiliation', 'parrainage', 'commission', 'referral', 'الإحالة', 'إحالة', 'عمولة', 'عمولات', 'نظام الإحالة', 'parrainer'] },

  // ── Espace personnel ──────────────────────────────────────────────────────
  { id: 'nav-personal-space', titleKey: 'nav_personal_space', subtitleKey: 'search_sub_personal_space', url: '/personal-space', scope: 'pages',
    keywords: ['espace personnel', 'personal space', 'المساحة الشخصية', 'مساحتي', 'mes fichiers', 'mes documents'] },

  // ── Profil & mot de passe ─────────────────────────────────────────────────
  { id: 'nav-profile',   titleKey: 'search_profile',     subtitleKey: 'search_sub_profile',    url: '/profile', scope: 'pages',
    keywords: ['profil', 'profile', 'compte', 'account', 'paramètres', 'settings', 'mon compte', 'إعدادات الحساب', 'حسابي', 'ملف شخصي', 'الإعدادات', 'avatar', 'photo'] },
  { id: 'nav-change-password', titleKey: 'search_change_password', subtitleKey: 'search_sub_change_password', url: '/profile', scope: 'pages',
    keywords: ['mot de passe', 'password', 'mdp', 'pwd', 'changer mot de passe', 'كلمة المرور', 'تغيير كلمة المرور', 'مرور', 'sécurité', 'security'] },

  // ── Support / Notifications / Activités ──────────────────────────────────
  { id: 'nav-support',        titleKey: 'search_support_page',        subtitleKey: 'search_sub_support_page',        url: '/support',        scope: 'pages',
    keywords: ['support', 'aide', 'help', 'assistance', 'contact', 'الدعم', 'مساعدة', 'دعم العملاء', 'problème', 'signaler'] },
  { id: 'nav-notifications',  titleKey: 'search_notifications_page',  subtitleKey: 'search_sub_notifications_page',  url: '/notifications',  scope: 'pages',
    keywords: ['notification', 'notifications', 'alerte', 'alertes', 'alert', 'الإشعارات', 'إشعار', 'تنبيه', 'تنبيهات', 'مستجدات'] },
  { id: 'nav-activities',     titleKey: 'search_activities_page',     subtitleKey: 'search_sub_activities_page',     url: '/activities',     scope: 'pages',
    keywords: ['activite', 'activites', 'activity', 'activities', 'historique', 'log', 'الأنشطة', 'نشاط', 'السجل', 'journal', 'traces'] },
  // Mock products/orders/customers — titles stay as-is (product names)
  { id: 'prod-1', title: 'Chemise Lin Blanc',      subtitle: 'En stock · 24 unités · 3 200 DZD',    url: '/products', scope: 'products' },
  { id: 'prod-2', title: 'Robe Été Fleurie',        subtitle: 'En stock · 12 unités · 5 500 DZD',    url: '/products', scope: 'products' },
  { id: 'prod-3', title: 'Pantalon Chino Beige',    subtitle: 'Stock faible · 2 unités · 4 100 DZD', url: '/products', scope: 'products' },
  { id: 'prod-4', title: 'Veste Jean Oversize',     subtitle: 'En stock · 8 unités · 7 800 DZD',     url: '/products', scope: 'products' },
  { id: 'prod-5', title: 'Sneakers Cuir Blanc',     subtitle: 'En stock · 15 unités · 6 200 DZD',    url: '/products', scope: 'products' },
  { id: 'prod-6', title: 'Sac Bandoulière Camel',   subtitle: 'En stock · 5 unités · 4 900 DZD',     url: '/products', scope: 'products' },
  { id: 'ord-1042', title: '#1042 — Ahmed Benali',      subtitle: '3 200 DA · En cours de traitement', url: '/orders', scope: 'orders' },
  { id: 'ord-1041', title: '#1041 — Sara Mansouri',     subtitle: '11 000 DA · Expédiée',              url: '/orders', scope: 'orders' },
  { id: 'ord-1040', title: '#1040 — Karim Lounès',      subtitle: '5 500 DA · Livrée',                 url: '/orders', scope: 'orders' },
  { id: 'ord-1039', title: '#1039 — Nadia Hamidi',      subtitle: '7 800 DA · Expédiée',               url: '/orders', scope: 'orders' },
  { id: 'ord-1038', title: '#1038 — Younes Aït Amara',  subtitle: '4 100 DA · Annulée',                url: '/orders', scope: 'orders' },
  { id: 'cust-1', title: 'Ahmed Benali',      subtitle: '3 commandes · Client depuis jan. 2024', url: '/customers', scope: 'customers' },
  { id: 'cust-2', title: 'Sara Mansouri',     subtitle: '7 commandes · Client fidèle',           url: '/customers', scope: 'customers' },
  { id: 'cust-3', title: 'Karim Lounès',      subtitle: '1 commande · Nouveau client',           url: '/customers', scope: 'customers' },
  { id: 'cust-4', title: 'Nadia Hamidi',      subtitle: '5 commandes · Client fidèle',           url: '/customers', scope: 'customers' },
  { id: 'cust-5', title: 'Younes Aït Amara',  subtitle: '2 commandes',                           url: '/customers', scope: 'customers' },
];

/** `canUseAgent` : accès KIOAGENT du compte (sinon l'entrée KIOAGENT est retirée). */
export function buildSearchIndex(t, canUseAgent = false) {
  const base = canUseAgent
    ? SEARCH_INDEX_BASE
    : SEARCH_INDEX_BASE.filter((item) => item.id !== 'nav-kioagent');
  return base.map(item => ({
    ...item,
    title: item.titleKey ? t(item.titleKey) : item.title,
    subtitle: item.subtitleKey ? t(item.subtitleKey) : item.subtitle,
    keywords: item.keywords || [],
  }));
}
